import {hitGoogleTagManager} from "../../tracking/google_tag_manager/hit_google_tag_manager";

interface offerRedirectTrackingPayload {
    city: string;
    position?: number;
    vendor?: string;
    offerName?: string;
}

export const offerRedirectTracking = (payload: offerRedirectTrackingPayload) => {
    const data = {
        event: "rankings_city",
        event_action: "click",
        event_label: getLabelFromPosition(payload.position),
        event_category: payload.city,
        ...(payload.vendor ? {event_category2: payload.vendor} : {}),
        ...(payload.offerName ? {event_category3: payload.offerName} : {})
    };

    hitGoogleTagManager(data);
};

const getLabelFromPosition = (position?: number) => {
    if (!position) {
        return `cta`;
    }

    if (position <= 3) {
        return `top${position}`;
    }

    return `featured`;
};
